import TEEmailLayout from './TEEmailLayout';

export default TEEmailLayout;
